import React, { useContext } from 'react';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import { parse } from 'node-html-parser';

// PropTypes
import { jobPropTypes } from '../../../../proptypes/jobProptypes';

// Context
import ApproachContext from '../../../../context/ApproachContext';

// Styles
import styles from './whatYouWillDoSection.module.scss';

const WhatYouWillDoSection = ({ job }) => {
  const router = useRouter();
  const approach = useContext(ApproachContext);
  const { t } = useTranslation('common');

  if (
    !job.extra_info?.your_role
    // && !job.extra_info?.management_role
  ) {
    return null;
  }

  const handleRenderYourRole = () => {
    const root = parse(job.extra_info?.your_role);
    const links = root.querySelectorAll('a');

    links?.forEach((link) => {
      const currentLink = link.getAttribute('href');

      if (currentLink.includes('jobs.lionstep.com')) {
        const queries = {
          utm_source: 'one_landing_page',
          utm_medium: job.id,
          utm_campaign: currentLink.split('/').pop(),
        };

        if (router.query?.uid) {
          queries.uid = router.query.uid;
        }
        if (router.query?.source) {
          queries.source = router.query.source;
        }

        if (router.query?.job_lang) {
          queries.job_lang = router.query.job_lang;
        }

        const queryString = Object.keys(queries)
          .map((key) => `${key}=${queries[key]}`)
          .join('&');

        link.setAttribute('href', `${currentLink}?${queryString}`);
      }
    });

    const modifiedHtmlString = root.toString();

    return modifiedHtmlString;
  };

  return (
    <section id="what-you-will-do-section" className={styles.container}>
      <h2 className={styles.heading}>
        {job.is_one_landing_page
          ? t(`description_page.what_you_will_do_section.olp_title.${approach}`)
          : t(`description_page.what_you_will_do_section.title.${approach}`)}
      </h2>

      {job.extra_info?.your_role && (
        <div
          className={`html-div ${styles.mainContent}`}
          dangerouslySetInnerHTML={{
            __html: handleRenderYourRole(job.extra_info.your_role),
          }}
        />
      )}

      {/* {job.extra_info?.management_role && (
        <ul className={styles.list}>
          <li>
            {t(`description_page.what_you_will_do_section.manages.${approach}`)}
            <span className={styles.separator}>:</span>{' '}
            {t(
              `description_page.what_you_will_do_section.direct_reports.${approach}`,
              {
                people_to_manage: job.extra_info?.peopleToManage,
              },
            )}
          </li>
        </ul>
      )} */}
    </section>
  );
};

WhatYouWillDoSection.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
};

export default WhatYouWillDoSection;
